import { DSBestListRatingsPage, LinkedLinkProps } from 'shared-definitions/types'
import { seeMoreProductPopupMapper } from 'data-source/mappers/seeMoreProductPopupMapper'
import BestListRatingsTemplate from 'shared-components/templates/BestListRatingsTemplate'
import { getds } from 'ds'
import { TypesenseFilter, TypesenseSearchQuery } from 'shared-code/typesense/typesense.types'
import { productSearchToCompareColumnsMapper } from 'data-source/mappers/productSearchToCompareColumnsMapper'
import { productSearchToProductChart } from 'data-source/mappers/productSearchToProductChart'
import { linkBuilder } from 'links'
import { compareProductPrefetchedInfoMapper } from 'data-source/mappers/compareProductPrefetchedInfoMapper'
import { DSNCSG } from 'types.sg.ds'
import NC from 'nc/NC'

export function postLinkBuilder(slug: string): LinkedLinkProps {
  return linkBuilder.buildSiteLink({ path: 'post', params: { slug } })
}

interface BestListRatingsSGProps {
  page: DSBestListRatingsPage<DSNCSG>
}

const BestListRatingsTemplateSG: React.FC<BestListRatingsSGProps> = ({ page }) => (
  <BestListRatingsTemplate
    nc={NC}
    onVote={async (productId, vote) => {
      const ds = await getds()
      return ds.sendProductVote({ productId, vote })
    }}
    page={page}
    onGetResults={async (filter, signal) => {
      const filterBy: TypesenseFilter[] = []

      // hidden filters
      page.filter.filterSettings.form.hiddenConditions.forEach(condition => {
        filterBy.push(condition)
      })

      // visible filters
      Object.entries(filter).forEach(([key, value]) => {
        if (typeof value === 'undefined' || value === null) {
          return
        }

        if (typeof value === 'string') {
          filterBy.push({ key, value, condition: 'equal' })
        }

        if (typeof value === 'object') {
          filterBy.push({ key, value: { from: value.min, to: value.max }, condition: 'equal' })
        }
      })

      const ds = await getds()
      const query: TypesenseSearchQuery = {
        q: '*',
        queryBy: [],
        limit: page.filter.filterSettings.limit,
        offset: 0,
        sortBy: page.filter.filterSettings.defaultSort
          ? [page.filter.filterSettings.defaultSort]
          : undefined,
        filterBy,
      }

      const result = await ds.getProductsSearchResults(query, signal)

      return {
        table: productSearchToCompareColumnsMapper(result.data, {
          postLinkBuilder,
          ...page.filterAdditionalInfo,
        }),
        chart: productSearchToProductChart(result.data, {
          postLinkBuilder,
          ...page.filterAdditionalInfo,
        }),
        primaryScoresInfo: compareProductPrefetchedInfoMapper(
          result.data.products,
          page.histogramMetrics
        ),
      }
    }}
    onSeeMore={async (productId, signal) => {
      const ds = await getds()
      const query: TypesenseSearchQuery = {
        q: '*',
        queryBy: [],
        limit: 1,
        offset: 0,
        filterBy: [
          {
            key: 'id',
            value: productId,
            condition: 'equal',
          },
        ],
      }

      const result = await ds.getProductsSearchResults(query, signal)
      if (result.data.products.length === 0) {
        throw new Error('Product not found')
      }

      return {
        seeMore: seeMoreProductPopupMapper(result.data.products[0], {
          postLinkBuilder,
          strings: page.filterAdditionalInfo.strings,
        }),
      }
    }}
  />
)

export default BestListRatingsTemplateSG
